import GLabel from './GLabel'

export { GLabel }
export default GLabel
